import { ShieldCheck } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useCourseModeration } from '@/features/moderation/useCourseModeration'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  courseId: number
}

/** Разметка плашки заморозки — общая с редактором статьи (`ArticleReviewLockNotice`). */
export const ReviewLockPlaque = ({ text, className }: { text: string; className?: string }) => (
  <div
    role="status"
    className={cn(
      'flex items-start gap-2.5 rounded-2xl border border-warning/30 bg-warning/10 p-3 text-sm text-warning',
      className,
    )}
  >
    <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0" />
    <p className="font-medium">{text}</p>
  </div>
)

/**
 * Плашка над канвасом, пока ревью курса `pending`: редактор заморожен целиком
 * (вторая причина общего лока, `useBlocksInRun` → `reason: 'review'`), и автору
 * нужно одно место, где сказано, почему и как выйти. Манера — как у
 * `BlockRunNotice`; иконка не крутится — идёт не работа, а ожидание решения.
 * Про отзыв заявки — только у неопубликованного курса: у живого окно публикации
 * кнопки отзыва не показывает (отзыв снял бы курс с публикации).
 */
export const ReviewLockNotice = ({ courseId }: Props) => {
  const m = useMessages(messages)
  const { state } = useCourseModeration(courseId)
  if (state?.review?.status !== 'pending') return null
  const canWithdraw = state.visibility === 'unpublished'
  return (
    <ReviewLockPlaque
      className="mx-2 mt-2"
      text={canWithdraw ? m.reviewLockWithdraw : m.reviewLock}
    />
  )
}
